import { useEffect, useRef, useState } from 'react'

import { setupSkeletonCountObserver } from '@/common/utils/calculateSkeletonCount'

export function TableRowSkeleton() {
  const [skeletonCount, setSkeletonCount] = useState(5)
  const rowRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    return setupSkeletonCountObserver(containerRef, rowRef, setSkeletonCount, 5)
  }, [])

  const renderSkeletonRow = () => (
    <div
      className="flex items-center gap-4 p-2 border-b border-base-200 animate-pulse w-full"
      ref={rowRef}
    >
      <div className="w-2/12 h-6 flex items-center">
        <div className="h-4 w-full bg-base-200 rounded" />
      </div>

      <div className="w-2/12 h-6 flex items-center">
        <div className="h-4 w-full bg-base-200 rounded" />
      </div>

      <div className="w-4/12 h-6 flex items-center">
        <div className="h-4 w-full bg-base-200 rounded" />
      </div>

      <div className="w-3/12 h-6 flex items-center">
        <div className="h-4 w-full bg-base-200 rounded" />
      </div>

      <div className="w-1/12 h-6 flex items-center">
        <div className="h-4 w-full bg-base-200 rounded" />
      </div>
    </div>
  )

  return (
    <div ref={containerRef} className="max-h-full overflow-y-auto">
      {Array.from({ length: skeletonCount }, (_, index) => (
        <div key={index}>{renderSkeletonRow()}</div>
      ))}
    </div>
  )
}
